import React from 'react'
import ProgressChart from './ProgressChart';
import ChartCard from './ChartCard';
import WhoAllCharts from './WhoAllCharts';
import EmojiChart from './EmojiChart';


const Dashboard = () => {
  return (
    <>
      <div className='w-full'>
        <div className='summery-width mx-auto pt-1'>
          <div className='flex gap-6 mt-3 lg:flex-col'>
            <div className='  flex flex-col gap-6 w-[67%] lg:w-[100%]'>
              {/* <div className=' shadow-metafit-shadow bg-white border rounded-[10px] col-sm-12'>
                <Tabs className='black-tab'>
                  <Tabs.TabPane tab="Mood Logs" key="1">
                    <div className='mt-5'>
                      <EmojiChart />
                    </div>
                  </Tabs.TabPane>

                  <Tabs.TabPane tab="Thought Logs" key="2">
                  <div className='mt-5'>
                      <EmojiChart />
                    </div>
                  </Tabs.TabPane>
                </Tabs>

              </div> */}
              <EmojiChart />
            </div>
            <div className='flex flex-col gap-6 w-[33%]  lg:items-center lg:w-[500px] '>
              <ChartCard title="Top Usage" >
                <ProgressChart />
              </ChartCard>
            </div>
          </div>
          <div className='mt-5'>
            <WhoAllCharts />
          </div>
        </div>
      </div>
    </>
  )
}

export default Dashboard;